import React, { useState ,useEffect} from "react";
import styles from "styles/genai/Edetail.module.scss";
import cardsstatus from "img/genai/cardstatus.svg";
import downloadicon from "img/genai/download.svg";
import suggestion from "img/genai/suggestions.svg";
import viewport from "img/genai/viewport.svg";
import tick from "img/genai/tick.svg";
import cross from "img/genai/cross.svg";
import styled from "styled-components";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { PreviewModal } from "../PreviewModal";
import { ToastContainer, toast } from "react-toastify";


export const SelectedRecSlide = ({ data,messages,messageId }) => {
  const [showModal, setShowModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [shouldGreyOut, setShouldGreyOut] = useState(false);



  const findLastSlideResMessage = () => {
    if (!messages || !Array.isArray(messages)) return null;
    
    // Filter messages with responseType "slideRes" and get the last one
    const slideResMessages = messages.filter(msg => msg.responseType === "slideRes");
    return slideResMessages.length > 0 ? slideResMessages[slideResMessages.length - 1] : null;
  };

  // Determine if current component should be greyed out
  useEffect(() => {
    if (!messages || !messageId) return;

    const lastSlideResMessage = findLastSlideResMessage();
    
    if (lastSlideResMessage) {
      // Grey out if current messageId is not the last slideRes message
      setShouldGreyOut(lastSlideResMessage.id !== messageId);
    } else {
      // If no slideRes messages found, don't grey out
      setShouldGreyOut(false);
    }
  }, [messages, messageId]);

  // Transform the combined data into the format needed for rendering
  const transformSlideData = () => {
    if (!data?.allSlides) return [];
    
    const { allSlides, recommendedSlides, originalSlides } = data;
    
    // Create header object
    const header = {
      maintitle: "Great! Following slides are selected by you.",
      maintitleTwo: "How would you like to make module?",
    };

    // Transform slides data - no duplicates now thanks to handleProceedSlides
    const slides = allSlides.slideIds.map((slideId, index) => {
      const signedUrlObj = allSlides.signedUrls?.find(url => url.pageId === slideId);
      const slidenum = allSlides.slidenums?.[index] || `Slide_${index + 1}`;
      const isOriginallySelected = originalSlides.slideIds.includes(slideId);
      const isRecommended = recommendedSlides.includes(slideId);
      
      return {
        id: slideId,
        image: signedUrlObj?.signedUrl || "placeHoldimg",
        slidenum: slidenum,
        isdisabled: false,
        pageNo: index + 1,
        claims: [],
        isOriginallySelected: isOriginallySelected,
        isRecommended: isRecommended,
      };
    });

    return [header, ...slides];
  };

  const transformedSlideData = transformSlideData();

  const preventContextMenu = (e) => e.preventDefault();

  const processPreviewData = (data) => {
    if (!data) return null;
    if (data.image && data.pageNo) {
      return {
        pageDetails: [
          {
            signedUrl: data.image,
            pageNo: data.pageNo,
          },
        ],
      };
    }
    if (Array.isArray(data.pageDetails)) {
      return data;
    }
    return null;
  };

  const handleImageClick = (slideOrEdetail) => {
    const normalized = processPreviewData(slideOrEdetail);
    if (!normalized) return;
    setPreviewData(normalized);
    setShowModal(true);
  };


  // Grey out style logic
  const greyOutStyle = {
    opacity: shouldGreyOut ? 0.5 : 1,
    pointerEvents: shouldGreyOut ? "none" : "auto",
    filter: shouldGreyOut ? "grayscale(80%)" : "none",
    transition: "all 0.3s ease",
  };


  return (
    <>
      <article className={`${styles.edetailmain} ${styles["slideRec"]}`} style={greyOutStyle} >
        <span style={{ width: '69rem' }}>
          <strong>{transformedSlideData[0]?.maintitle}</strong>
        </span>

        <div className={styles.eslidecontainer}>
          {transformedSlideData.slice(1).map((ele, index) => (
            <article
              key={`${ele.id}-${index}`}
              className={`${styles.eslidesub} ${ele.isRecommended ? styles.recommendedSlide : ''}`}
            >
              {/* {ele.isRecommended && (
                <div className={styles.recommendedBadge}>
                  Recommended
                </div>
              )} */}
              
              {/* {ele.isOriginallySelected && !ele.isRecommended && (
                <div className={styles.originalBadge}>
                  Originally Selected
                </div>
              )} */}
              
              {/* {ele.isOriginallySelected && ele.isRecommended && (
                <div className={styles.bothBadge}>
                  Selected & Recommended
                </div>
              )} */}

              <div
                className={`${styles.imageContainer}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleImageClick(ele);
                }}
              >
                <img
                  className={`${styles.cardsimg} ${styles["slideRec"]}`}
                  src={ele.image}
                  alt={`Slide ${ele.pageNo}`}
                  style={{ objectFit: "fill" }}
                  onContextMenu={preventContextMenu}
                />

                <div
                  className={styles.previewOverlay}
                  onContextMenu={preventContextMenu}
                >
                  <article className={styles.previewBox}>
                    <img src={viewport} alt="view" />
                    <span>Preview</span>
                  </article>
                </div>
              </div>

              <article className={`${styles.eslidebottom}`}>
                <div className={styles.leftecard}>
                  <span className={styles.cardstatus}>
                    <strong>{ele.slidenum}</strong>
                  </span>
                </div>
                <div className={styles.rightecard}>

                </div>
              </article>
            </article>
          ))}
        </div>
        
        <span style={{ width: '69rem' }}>
          <strong>{transformedSlideData[0]?.maintitleTwo}</strong>
        </span>
      </article>

      {previewData && (
        <PreviewModal
          show={showModal}
          onClose={() => setShowModal(false)}
          previewData={previewData}
        />
      )}
    </>
  );
}


